/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { Actividad } from '../model/actividad';
import { ActividadBase } from '../model/actividadBase';
import { ActividadPatch } from '../model/actividadPatch';
import { ApiError } from '../model/apiError';
import { FotoEvento } from '../model/fotoEvento';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class ActividadesService {

    protected basePath = 'https://virtserver.swaggerhub.com/yohanyflores/kogui/1.0.0';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Elimina una actividad. Previa verificacion de las reservas pendientes.
     * @param empresaId Especifica la empresaid.
     * @param actividadId El id de un evento asociado a la empresa.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteEmpresaByIdActividadById(empresaId: string, actividadId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteEmpresaByIdActividadById(empresaId: string, actividadId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteEmpresaByIdActividadById(empresaId: string, actividadId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteEmpresaByIdActividadById(empresaId: string, actividadId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling deleteEmpresaByIdActividadById.');
        }
        if (actividadId === null || actividadId === undefined) {
            throw new Error('Required parameter actividadId was null or undefined when calling deleteEmpresaByIdActividadById.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.delete<any>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/actividades/${encodeURIComponent(String(actividadId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene informacion de la foto.
     * Obtiene informacion de la foto con el id especificado.
     * @param empresaId Especifica la empresaid.
     * @param actividadId El id de una actividad asociado a la empresa.
     * @param fotoId El id de la foto.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteEmpresaByIdActividadesByIdFotoById(empresaId: string, actividadId: string, fotoId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteEmpresaByIdActividadesByIdFotoById(empresaId: string, actividadId: string, fotoId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteEmpresaByIdActividadesByIdFotoById(empresaId: string, actividadId: string, fotoId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteEmpresaByIdActividadesByIdFotoById(empresaId: string, actividadId: string, fotoId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling deleteEmpresaByIdActividadesByIdFotoById.');
        }
        if (actividadId === null || actividadId === undefined) {
            throw new Error('Required parameter actividadId was null or undefined when calling deleteEmpresaByIdActividadesByIdFotoById.');
        }
        if (fotoId === null || fotoId === undefined) {
            throw new Error('Required parameter fotoId was null or undefined when calling deleteEmpresaByIdActividadesByIdFotoById.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.delete<any>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/actividades/${encodeURIComponent(String(actividadId))}/fotos/${encodeURIComponent(String(fotoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene el detalle de una actividad por su id.
     * @param empresaId Especifica la empresaid.
     * @param actividadId El id de un evento asociado a la empresa.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresaByIdActividadById(empresaId: string, actividadId: string, observe?: 'body', reportProgress?: boolean): Observable<Actividad>;
    public getEmpresaByIdActividadById(empresaId: string, actividadId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Actividad>>;
    public getEmpresaByIdActividadById(empresaId: string, actividadId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Actividad>>;
    public getEmpresaByIdActividadById(empresaId: string, actividadId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresaByIdActividadById.');
        }
        if (actividadId === null || actividadId === undefined) {
            throw new Error('Required parameter actividadId was null or undefined when calling getEmpresaByIdActividadById.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Actividad>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/actividades/${encodeURIComponent(String(actividadId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene informacion de la foto.
     * Obtiene informacion de la foto con el id especificado.
     * @param empresaId Especifica la empresaid.
     * @param actividadId El id de una actividad asociado a la empresa.
     * @param fotoId El id de la foto.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresaByIdActividadesByIdFotoById(empresaId: string, actividadId: string, fotoId: string, observe?: 'body', reportProgress?: boolean): Observable<FotoEvento>;
    public getEmpresaByIdActividadesByIdFotoById(empresaId: string, actividadId: string, fotoId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FotoEvento>>;
    public getEmpresaByIdActividadesByIdFotoById(empresaId: string, actividadId: string, fotoId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FotoEvento>>;
    public getEmpresaByIdActividadesByIdFotoById(empresaId: string, actividadId: string, fotoId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresaByIdActividadesByIdFotoById.');
        }
        if (actividadId === null || actividadId === undefined) {
            throw new Error('Required parameter actividadId was null or undefined when calling getEmpresaByIdActividadesByIdFotoById.');
        }
        if (fotoId === null || fotoId === undefined) {
            throw new Error('Required parameter fotoId was null or undefined when calling getEmpresaByIdActividadesByIdFotoById.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<FotoEvento>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/actividades/${encodeURIComponent(String(actividadId))}/fotos/${encodeURIComponent(String(fotoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene las fotos del evento.
     * Obtiene las fotos del evento.
     * @param empresaId Especifica la empresaid.
     * @param actividadId El id de una actividad asociado a la empresa.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresaByIdActividadesByIdFotos(empresaId: string, actividadId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<FotoEvento>>;
    public getEmpresaByIdActividadesByIdFotos(empresaId: string, actividadId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FotoEvento>>>;
    public getEmpresaByIdActividadesByIdFotos(empresaId: string, actividadId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FotoEvento>>>;
    public getEmpresaByIdActividadesByIdFotos(empresaId: string, actividadId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresaByIdActividadesByIdFotos.');
        }
        if (actividadId === null || actividadId === undefined) {
            throw new Error('Required parameter actividadId was null or undefined when calling getEmpresaByIdActividadesByIdFotos.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<FotoEvento>>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/actividades/${encodeURIComponent(String(actividadId))}/fotos/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene la lista de eventos paginadas. por defecto se ordenan en orden descendiente de creacion.
     * Al obtener las actividadesd puede especificar una paginacion y orden para mostrarlo.
     * @param empresaId Especifica la empresaid.
     * @param $filter 
     * @param $size 
     * @param $page 
     * @param $sort 
     * @param $fields 
     * @param $search Permite buscar por fulltext.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresasByIdActividades(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Actividad>>;
    public getEmpresasByIdActividades(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Actividad>>>;
    public getEmpresasByIdActividades(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Actividad>>>;
    public getEmpresasByIdActividades(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresasByIdActividades.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($filter !== undefined && $filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>$filter);
        }
        if ($size !== undefined && $size !== null) {
            queryParameters = queryParameters.set('$size', <any>$size);
        }
        if ($page !== undefined && $page !== null) {
            queryParameters = queryParameters.set('$page', <any>$page);
        }
        if ($sort !== undefined && $sort !== null) {
            queryParameters = queryParameters.set('$sort', <any>$sort);
        }
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }
        if ($search !== undefined && $search !== null) {
            queryParameters = queryParameters.set('$search', <any>$search);
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Actividad>>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/actividades/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param empresaId Especifica la empresaid.
     * @param actividadId El id de un evento asociado a la empresa.
     * @param actividadPatch Solicitud de Patch sobre la actividad.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchEmpresaByIdActividadById(empresaId: string, actividadId: string, actividadPatch?: ActividadPatch, observe?: 'body', reportProgress?: boolean): Observable<ActividadPatch>;
    public patchEmpresaByIdActividadById(empresaId: string, actividadId: string, actividadPatch?: ActividadPatch, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActividadPatch>>;
    public patchEmpresaByIdActividadById(empresaId: string, actividadId: string, actividadPatch?: ActividadPatch, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActividadPatch>>;
    public patchEmpresaByIdActividadById(empresaId: string, actividadId: string, actividadPatch?: ActividadPatch, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling patchEmpresaByIdActividadById.');
        }
        if (actividadId === null || actividadId === undefined) {
            throw new Error('Required parameter actividadId was null or undefined when calling patchEmpresaByIdActividadById.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<ActividadPatch>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/actividades/${encodeURIComponent(String(actividadId))}`,
            actividadPatch,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sube una foto o recurso asocida a un Evento.
     * Permite subir una fotos o un conjunto de fotos.
     * @param empresaId Especifica la empresaid.
     * @param actividadId El id de una actividad asociado a la empresa.
     * @param fotoFile 
     * @param fotoUri 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postEmpresaByIdActividadesByIdFotos(empresaId: string, actividadId: string, fotoFile?: Blob, fotoUri?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public postEmpresaByIdActividadesByIdFotos(empresaId: string, actividadId: string, fotoFile?: Blob, fotoUri?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public postEmpresaByIdActividadesByIdFotos(empresaId: string, actividadId: string, fotoFile?: Blob, fotoUri?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public postEmpresaByIdActividadesByIdFotos(empresaId: string, actividadId: string, fotoFile?: Blob, fotoUri?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling postEmpresaByIdActividadesByIdFotos.');
        }
        if (actividadId === null || actividadId === undefined) {
            throw new Error('Required parameter actividadId was null or undefined when calling postEmpresaByIdActividadesByIdFotos.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: this.encoder});
        }

        if (fotoFile !== undefined) {
            formParams = formParams.append('fotoFile', <any>fotoFile) as any || formParams;
        }
        if (fotoUri !== undefined) {
            formParams = formParams.append('fotoUri', <any>fotoUri) as any || formParams;
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/actividades/${encodeURIComponent(String(actividadId))}/fotos/`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea una nuevo actividad, en estado borrador.
     * Crea una nuevo actividad. La actividad es creado en estado borrador. Para permitir su edicion y cambio de estado.
     * @param empresaId Especifica la empresaid.
     * @param actividadBase Un Objeto JSON que representa la informacion del Evento a crear.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postEmpresasByIdActividadess(empresaId: string, actividadBase?: ActividadBase, observe?: 'body', reportProgress?: boolean): Observable<Actividad>;
    public postEmpresasByIdActividadess(empresaId: string, actividadBase?: ActividadBase, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Actividad>>;
    public postEmpresasByIdActividadess(empresaId: string, actividadBase?: ActividadBase, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Actividad>>;
    public postEmpresasByIdActividadess(empresaId: string, actividadBase?: ActividadBase, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling postEmpresasByIdActividadess.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Actividad>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/actividades/`,
            actividadBase,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
